export const typeInfo = Object.freeze({
  analysis: {
    text: "지문분석",
    color: "#1DB05B",
    backgroundColor: "#E8F7EE",
    answerTextColor: "white",
    badgeColor: "rgba(29, 176, 91, 0.35)",
  },
  comprehensive: {
    text: "내용이해",
    color: "#E8920A", // [색 스왑] 원래 톤 복귀 — 내용이해=오렌지
    backgroundColor: "#FDF3E3",
    answerTextColor: "white",
    badgeColor: "rgba(232, 146, 10, 0.35)",
  },
  paragraph: {
    text: "모의고사",
    color: "#C2452D",
    backgroundColor: "#FCEDE9",
    answerTextColor: "white",
    badgeColor: "rgba(194, 69, 45, 0.32)",
  },
  vocabulary: {
    text: "단어테스트",
    color: "#3E6398",
    backgroundColor: "#E9EFF7",
    answerTextColor: "white",
    badgeColor: "rgba(62, 99, 152, 0.32)",
  },
  sentence: {
    text: "문장테스트",
    color: "#8A6D00",
    backgroundColor: "#FBF4D9",
    answerTextColor: "white",
    badgeColor: "rgba(138, 109, 0, 0.32)",
  },
  // 지인에듀 수학 학습지(2026-10-06). 연산(드릴)은 청록, 유형은 보라 · 풀이 화면의 색과 맞춘다
  math_type_worksheet: {
    text: "수학 유형",
    color: "#6A5AE0",
    backgroundColor: "#EFEDFC",
    answerTextColor: "white",
    badgeColor: "rgba(106, 90, 224, 0.32)",
  },
  math_variant: {
    text: "수학 변형",
    color: "#6A5AE0",
    backgroundColor: "#EFEDFC",
    answerTextColor: "white",
    badgeColor: "rgba(106, 90, 224, 0.32)",
  },
  math_concept: {
    text: "수학 개념",
    color: "#6A5AE0",
    backgroundColor: "#EFEDFC",
    answerTextColor: "white",
    badgeColor: "rgba(106, 90, 224, 0.32)",
  },
  // 오답노트 쌍둥이 과제(2026-10-06). 오답 표시와 같은 분홍
  math_wrong_note: {
    text: "수학 오답",
    color: "#D63C5E",
    backgroundColor: "#FFE8EE",
    answerTextColor: "white",
    badgeColor: "rgba(214, 60, 94, 0.32)",
  },
  math_drill: {
    text: "수학 연산",
    color: "#00A396",
    backgroundColor: "#E6F7F4",
    answerTextColor: "white",
    badgeColor: "rgba(0, 163, 150, 0.32)",
  },
  // 리더스북(지인에듀, 2026-10-17). 교사 화면 WorksheetTypeBox 와 같은 색
  readers_book: {
    text: "리더스북",
    color: "#D14D72",
    backgroundColor: "#FCEBF1",
    answerTextColor: "white",
    badgeColor: "rgba(209, 77, 114, 0.32)",
  },
  bank: {
    text: "문제뱅크",
    color: "#00A396",
    backgroundColor: "#EFFBF8",
    answerTextColor: "white",
    badgeColor: "rgba(0, 163, 150, 0.32)",
  },
  // 지인에듀 문법뱅크(2026-10-24). 문제뱅크와 다른 메뉴 · 이름이다
  grammar_bank: {
    text: "문법",
    color: "#6B4EE6",
    backgroundColor: "#EFEBFC",
    answerTextColor: "white",
    badgeColor: "rgba(107, 78, 230, 0.32)",
  },
  grammar: {
    text: "어법테스트",
    color: "#6B4EE6", // [색 스왑] 원래 톤 복귀 — 어법=보라
    backgroundColor: "#EFEBFC",
    answerTextColor: "white",
    badgeColor: "rgba(107, 78, 230, 0.32)",
  },
  paper_assignment: {
    text: "지필과제",
    color: "#00A396",
    backgroundColor: "#E5FBF8",
    answerTextColor: "white",
    badgeColor: "rgba(0, 163, 150, 0.32)",
  },
  class_content: {
    text: "수업결과",
    color: "#3A434E",
    backgroundColor: "#F4F8F7",
    answerTextColor: "white",
    badgeColor: "rgba(58, 67, 78, 0.28)",
  },
});

export const SENTENCE_SECTION_ORDER = {
  translation: 1,    // 해석
  blank: 2,          // 빈칸
  scramble: 3,       // 스크램블
  composition: 4,    // 영작
  comprehensive: 5,  // 종합
  dictation: 6,      // 받아쓰기
};

// 파닉스북(리더스북 중 이름이 'ECHO Phonics · …' / 'Ginedu Phonics · …')은 단색 대신 분홍→보라 그라데이션
// 'Phonics' 로 단다(2026-10-20 대표). 교사 화면 WorksheetTypeBox 와 같은 색이다.
export const isPhonicsBookAssignment = (type, title) =>
  type === "readers_book" && /(ECHO|Ginedu) Phonics/.test(String(title || ""));
export const PHONICS_BADGE_TEXT = "Phonics";
export const PHONICS_BADGE_STYLE = {
  background: "linear-gradient(120deg, #F0568C 0%, #B24BD8 55%, #7B3FE4 100%)",
  color: "#FFFFFF",
  boxShadow: "0 2px 6px -2px rgba(178, 75, 216, 0.55)",
};

// ECHO 발음기호(리더스북 유형, 이름 'ECHO 발음기호 N', api assignment/ipa_course.py)는 남색 그라데이션 '발음기호'
const IPA_COURSE_BADGE = {
  text: "발음기호",
  style: {
    background: "linear-gradient(120deg, #4C7BF3 0%, #3A5BD9 55%, #2B3FA8 100%)",
    color: "#FFFFFF",
    boxShadow: "0 2px 6px -2px rgba(58, 91, 217, 0.55)",
  },
};

// 리더스북 중 따로 이름표를 다는 것(파닉스북 · 발음기호). 아니면 null 이라 유형 이름표를 그대로 쓴다
export const bookBadgeOf = (type, title) => {
  if (type !== "readers_book") return null;
  if (/^ECHO 발음기호/.test(String(title || ""))) return IPA_COURSE_BADGE;
  if (isPhonicsBookAssignment(type, title)) return { text: PHONICS_BADGE_TEXT, style: PHONICS_BADGE_STYLE };
  return null;
};
